/* 🤖 this file was generated by svg-to-ts */
export const kzIconsShare: {
  name: 'share';
  data: string;
} = {
  name: 'share',
  data: `<svg data-name="Layer 1" viewBox="0 0 512 512" fill="currentColor"><path class="cls-1" d="M405.33 298.67a106.54 106.54 0 0 0-83.9 40.86l-111.74-55.87a106.78 106.78 0 0 0 0-55.31l111.75-55.87a106.27 106.27 0 1 0-19.13-38.15L190.56 190.2a106.67 106.67 0 1 0 0 131.6l111.75 55.87a106.67 106.67 0 1 0 103-79Zm0-256a64 64 0 1 1-64 64 64.07 64.07 0 0 1 64-64ZM106.67 320a64 64 0 1 1 64-64 64.07 64.07 0 0 1-64 64Zm298.66 149.33a64 64 0 1 1 64-64 64.07 64.07 0 0 1-64 64Z"/></svg>`
};
